export default "__VITE_ASSET__TpZW7I1k__"